import type { HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';

const getVariantCount = ({ vehicles }: { vehicles: HsiycSearchVehiclesRecord[] }): number => {
  const uniqueVariants = new Set<string>();

  vehicles.forEach((vehicle) => {
    if (vehicle && vehicle.redbookCode) {
      uniqueVariants.add(vehicle.redbookCode);
    }
  });

  return uniqueVariants.size;
};

export default getVariantCount;
